export function isValidRedirectPath(path) {
  const regex = /^\/dashboard\/.*/
  return regex.test(path)
}
